export const passwordRequirementsCheck = {
  lowercase: (value) => /(.*[a-z].*)/.test(value),
  special: (value) => /(.*[!%&@#$^*?_~.].*)/.test(value),
  capital: (value) => /(.*[A-Z].*)/.test(value),
  number: (value) => /(.*\d.*)/.test(value),
  nospaces: (value) => /^\S*$/.test(value),
  length: (value) => value.length >= 10,
};

const showPasswordHint = (element, value) => {
  // on each input changes, go through each password requirement and check if fullfilled
  // updates it visual state, and return state for whole input at the end
  const showHint = Object.entries(passwordRequirementsCheck).reduce(
    (hintState, [requirement, checkFn]) => {
      const fullfilled = checkFn(value);
      element
        .find(`li[data-requirement="${requirement}"]`)
        .toggleClass('success', fullfilled);
      return hintState || !fullfilled;
    },
    false
  );

  element.toggleClass('input-hint-visible', showHint);
};

export const addPasswordHintToForm = (formSelector, passwordFieldName) => {
  const passwordFieldInput = formSelector.find(
    `input[name="${passwordFieldName}"]`
  );
  const passwordFieldHint = formSelector.find(
    `input[name="${passwordFieldName}"]+.input-hint`
  );

  const showPasswordHintWrapper = ($event) => {
    const { value } = $event.target;
    showPasswordHint(passwordFieldHint, value);
  };

  passwordFieldInput.on('input', showPasswordHintWrapper);

  $(window).on('unload', () => {
    passwordFieldInput.off('input', showPasswordHintWrapper);
  });
};
